'use strict';

import {module} from '../../app';

module.service('mathHelper', [
  function () {
    return {
      lineDistance: function (p1, p2) {
        let xs = 0;
        let ys = 0;

        xs = p2[0] - p1[0];
        xs = xs * xs;

        ys = p2[1] - p1[1];
        ys = ys * ys;

        return Math.sqrt(xs + ys);
      },

      getPerpendicular: function (p1, p2, dist) {
        let angle = Math.atan2(p2[1] - p1[1], p2[0] - p1[0]);

        let line = [
          [
            (Math.sin(angle) * dist + p2[0]), (-Math.cos(angle) * dist + p2[1])
          ],
          [
            (-Math.sin(angle) * dist + p2[0]), (Math.cos(angle) * dist + p2[1])
          ]
        ];

        return line;
      },

      max: function (array) {
        return Math.max.apply(Math, array);
      },

      min: function (array) {
        return Math.min.apply(Math, array);
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/services/svg/mathHelper.js